import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import { PauseIcon } from '../../icons/pause';
import { PlayCircleIcon } from '../../icons/play-circle';

import styles from './big-play-button.module.css';

type Props = {
  isPlaying?: boolean;
  onClick?: () => void;
  className?: string;
};

export function BigPlayButton({ isPlaying = false, onClick, className }: Props) {
  const { t } = useTranslation();

  const playButtonLabel = t('ui.play.button.label.active');
  const pauseButtonLabel = t('ui.play.button.label.inactive');

  return isPlaying ? (
    <button
      type="button"
      name="big-pause-button"
      aria-label={playButtonLabel}
      className={classNames(styles.button, className)}
      onClickCapture={onClick}
    >
      <PauseIcon />
    </button>
  ) : (
    <button
      type="button"
      name="big-play-button"
      aria-label={pauseButtonLabel}
      className={classNames(styles.button, className)}
      onClickCapture={onClick}
    >
      <PlayCircleIcon />
    </button>
  );
}
